// Verse.js

import {
    axios,
    useImperativeHandle, forwardRef, useRef, useContext, useState, useEffect,
    useSelector, useDispatch,
    useLocation, useNavigate, Link,
    AppTheme,
    mui, reducer, component, useShared,  
    replaceTabVerseListNewItem, setRead, getYearOfBirthList, localizedDateTime, verseRangeChineseName, sortResultList, canPushNewEntry, Highlight, resetSelectedAll, getBookChapterVerseChineseName, getChapterChineseName, getBookChapterChineseName, getTabLabel,
    VERSION, COUNTRY_LIST, MAX_LENGTH_SEARCH_STRING, MAX_LENGTH_NOTE_CONTENT, MAX_LENGTH_NOTE_TITLE, SPACE, API_BASE_URL, MAX_LENGTH_NON_SEARCH_STRING1, MAX_LENGTH_NON_SEARCH_STRING2,
    homeContext, searchContext, noteContext,
} from '../Utilities/sharedHeader';

export default function Verse({ tabNumber }){

  const { Slider, Snackbar, styled, grey, Grid, Chip, Divider, Tab, Tabs, Box, Accordion, AccordionSummary, AccordionDetails, ListItemIcon, List, ListItem, ListItemText, TextField, IconButton, InputBase, Paper, Alert, Select, FormControl, FormControlLabel, FormLabel, FormGroup, MenuItem, Container, Typography, ButtonGroup, Button, Stack, Fab, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Radio, RadioGroup, AppBar, Toolbar, Table, TableContainer, TableBody, TableRow, TableCell, CardMedia, CardContent, CssBaseline, FormHelperText, Switch, Card, CheckIcon, ClearIcon, DeleteIcon, CloseIcon, ExpandMoreIcon, VisibilityOutlinedIcon, KeyboardArrowUpIcon, KeyboardDoubleArrowUpIcon, HistoryIcon, StickyNote2Icon, NoteAddIcon, SearchIcon, DescriptionIcon, EditDocumentIcon, ImportContactsIcon, WestIcon, EastIcon, HomeIcon, PersonIcon, LogoutIcon, PlagiarismIcon, DeviceThermostatIcon, FileCopyIcon, LocalOfferIcon, InfoIcon } = mui;
  const { setButtonTextDialog4, setButtonText, setDialogTitle, setBookReadLogToBeCleared, setCallerConfirmationDialog, setCaller4NoteBookmarkList, setNoteSearchString, setConfirmedNoteSearchString, setNoteSearchStringClearButton, setShowRemainingNoteSearch, setSearchCriteriaListItem2, setSearchResultVerseList2, setPageNumberNoteSearch, setVerseListItem2, setNoteSearchStringPlaceHolder, reset4NoteSearch, setTabVerseListNew, reset4SignIn, setTitleToBeDeleted, reset4ConfirmationDialog, reset4GoToTopButtonVisible, reset4NoteBookmarkList, reset4Dialog4, reset4NoteBookmarkVerseList, reset4ChipArray, reset4verseLabelArrows4Result, reset4Switch1, reset4Dialog2, reset4Search, reset4Verse, reset4Chapter, reset4Book, reset4Home, setGoToTopButtonVisible, setVerseListItem, setNonSearchString1PlaceHolder, setNonSearchString2PlaceHolder, setSearchStringPlaceHolder, setSearchString, setShowLeftArrowVerseSearch, setShowRightArrowVerseSearch, setShowfabContentVerseSearch, setShowLeftArrowNote, setShowRightArrowNote, setShowfabContentNote, setShowLeftArrowNoteSearch, setShowRightArrowNoteSearch, setShowfabContentNoteSearch, setSearchCriteriaListItem, setPageNumberVerseSearch, setOpenConfirmationDialog, setOpen3, setConfirmedTabNumber, setOpen2, setPageNumberNote, setDetails, setLengthIndicator4Details, setLengthIndicator4Title, setLoading, setHistoryList, setHistoryListItemSelected, setHistoryBookChapter, setNoteBookmarkList, setNoteBookmarkListBookChapterVerse, setConfirmedSearchString, setNonSearchString1, setNonSearchString2, setSearchStringClearButton, setNonSearchStringClearButton, setSearchScopeList, setSearchScopeListItemSelected, setChipData, setShowRemaining, setSearchResultVerseList, setSearchHttpPostData, setBookChapterList, setBookChapterListItemSelected, setOpen1, setBookListItemSelected, setSearchCriteria, setLoading4Home, setUserListItem, setVerseReadLogList4Book, setSearchTabNumber, setBookChapter, setBookList, setTitle, setTitleClearButton, setBook4Accordion1, setChapter4Accordion1, setVerse4Accordion1, setBookChapter2, setBookChapterList2, setVerseList4Accordion1, setNoteBookmarkVerseList, setNoteBookmarkListItemToBeDeleted, setNoteBookmarkListItemToBeChanged, setTab4AddChange, setViewArea, setCredential, setCircularProgressText, setEmailExisted, setUsernameExisted, setLastNameOverMaxLength, setFirstNameOverMaxLength, reset4Profile } = reducer;
  const { SignUpEmailSent, Profile4System, Profile4Personal, History, AddChangeNote, FullFormatVerse, Book, Stack1, NoteVerseList, Chapter, Dialog1, Dialog2, Dialog3, Dialog4, Tab1, Navbar, VerseSearch, Verse, NoteBookmarkList, NoteBookmarkListItem, VerseLabelArrows4Result, ConfirmationDialog, Accordion1, ChipArray, SearchResult, ForgotPassword, ClipLoader1, VerseLabelArrows, Switch1, Selection, Profile, UserListItem } = component;  
  const { postUserListItem, bookRead, deleteVerseReadLogList, getNoteBookmarkList3, deleteLogListItem, getToken, postLogListItem, postPutSearchCriteriaListItem, deleteVerseReadLogListItem, postPutVerseReadLogListItem, postHistoryListItem, getHasNoteVersesAll, getSearchResultVerseList, getSearchCriteriaListItem, postNoteBookmarkListItem, putNoteBookmarkListItem2, putNoteBookmarkListItem1, getNoteBookmarkList, getVerseReadLogList4Book, getSearchScopeList, getVerseList4Accordion1, getUserListItem, getVerseList, getBookList, getHistoryList, putUserListItem } = useShared();

  const dispatch = useDispatch(); // dispatch(
  const searchCriteria = useSelector((state) => state.home.searchCriteria);
  const tabVerseListNew = useSelector((state) => state.verse.tabVerseListNew);
  const confirmedTabNumber = useSelector((state) => state.home.confirmedTabNumber);
  const viewArea = useSelector((state) => state.home.viewArea);
  const loading4Home = useSelector((state) => state.home.loading4Home);

  const byVerseSetTabVerseListNew = ({ verseTotal }) => {
    let showLeftArrow;
    let showRightArrow;
    let book = tabVerseListNew[confirmedTabNumber].book;
    let chapter = tabVerseListNew[confirmedTabNumber].chapter;
    if (book === 1 && chapter === 1) {
      showLeftArrow = false;
      showRightArrow = true;
    } else if (book === 66 && chapter === 22) {
      showLeftArrow = true;
      showRightArrow = false;
    } else {
      showLeftArrow = true;
      showRightArrow = true;
    }
    let list = tabVerseListNew.map((item, index) => index === confirmedTabNumber ? { ...item, book: book, chapter: chapter, verseTotal: verseTotal, showLeftArrow: showLeftArrow, showRightArrow: showRightArrow } : item)
    dispatch(setTabVerseListNew(list));
  }

  const handleOnClickVerseNumber = (book, chapter, verse) => {

    dispatch(setConfirmedTabNumber(-1));
    dispatch(setPageNumberNote(0));
    dispatch(setShowLeftArrowNote(false));
    dispatch(setShowRightArrowNote(true));
    dispatch(setShowfabContentNote(true));
    let bookChapterVerse = {book: book, chapter: chapter, verse: verse};
    dispatch(setNoteBookmarkListBookChapterVerse(bookChapterVerse));
    dispatch(setViewArea('Note'));

  }

  const handleOnClickSelected = (verseNumber) => {

    const verses = tabVerseListNew[tabNumber].verses.map((item, index) => index === verseNumber-1 ? { ...item, selected: !item.selected } : item);

    const newTabVerseListNewItem = { ...tabVerseListNew[tabNumber], verses: verses };
    const updatedTabVerseListNew = replaceTabVerseListNewItem(tabVerseListNew, tabNumber, newTabVerseListNewItem);
    dispatch(setTabVerseListNew(updatedTabVerseListNew));

  };

  useEffect(() => {
    if (tabVerseListNew[tabNumber].book > 0 && tabVerseListNew[tabNumber].chapter > 0) {
      // prevTabNumberRef.current = tabNumber;
      // prevBookRef.current = tabVerseListNew[tabNumber].book;
      // prevChapterRef.current = tabVerseListNew[tabNumber].chapter;
      getVerseList(tabNumber, 'Verse');
    }
    // if (confirmedTabNumber >= 0) {
    //   // byVerseSetTabVerseListNew({ verseTotal: tabVerseListNew[tabNumber].verses.length });
    // }    
  }, [tabVerseListNew[tabNumber].book, tabVerseListNew[tabNumber].chapter]);

  return (

    <div>

      <Grid container spacing={2}>

        <Grid>
          <TableContainer>
            <Table>
              <TableBody>
                {tabVerseListNew[tabNumber].verses.map((item, index) => (
                  <TableRow 
                    key={index+1}
                    sx={{
                      backgroundColor: item.selected ? theme => theme.palette.grey[300] : "inherit",
                    }}          
                  >
                    <TableCell sx={{ verticalAlign: 'top', paddingTop: 1, paddingBottom: 0, border: 'none' }} >
                      <FullFormatVerse tabNumber={tabNumber} hasNote={item.hasNote} handleOnClickVerseNumber={handleOnClickVerseNumber} handleOnClickSelected={handleOnClickSelected} book={tabVerseListNew[tabNumber].book} chapter={tabVerseListNew[tabNumber].chapter} verse={index+1} details={item.details} searchCriteria={searchCriteria} verseNumberOnly={true}/>
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>    
          </TableContainer>        
        </Grid>

        <Grid
            size={12}
            sx={{
              display: 'flex',
              justifyContent: 'center', // horizontally center
              mt: 1, 
              mb: 10
            }}
        >
          <div style={{ display: tabVerseListNew[tabNumber].verses.length > 0 && viewArea !== 'VerseSearch' && viewArea !== 'Note' ? 'block' : 'none' }}>
            <Switch1 />
          </div>
        </Grid>

        <Grid>
          <div style={{ display: tabVerseListNew[tabNumber].verses.length > 0 && viewArea !== 'VerseSearch' && viewArea !== 'Note' ? 'block' : 'none' }}>
            <VerseLabelArrows />
          </div>          
        </Grid>

      </Grid>
      
      {loading4Home && <ClipLoader1 />}

    </div>

  )    

}